import { EventEmitter } from '@angular/core';
import { EventNames } from './event-names';

export class EventEmitterService {
  private static emitters: {
    [eventName: string]: EventEmitter<any>
  } = {};

  static get(eventName: string): EventEmitter<any> {
    if (!this.emitters[eventName]) {
      this.emitters[eventName] = new EventEmitter<any>();
    }
    return this.emitters[eventName];
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/event-emitter/event-emitter.service.ts